import './style/pricing-table.scss';
